
    const data = {"name":"src/core/icons/image-outline","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M19 19H5V5h14m0-2H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2m-5.04 9.29-2.75 3.54-1.96-2.36L6.5 17h11l-3.54-4.71Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            